/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { openModal } from 'store/modals/actions';
import { getUserAgent, unSelectAll } from 'store/Agents/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import { useDispatch } from 'react-redux';
import Button from './styled';

const ConfigureAndRun = ({ agent }) => {
  const dispatch = useDispatch();
  const id = get(agent, 'id', null);
  const isOnline = get(agent, 'is_online', true);
  const status = get(agent, 'status', 'online');
  const disabled = !isOnline || (isOnline && status !== 'online');

  const onTriggerAgent = () => {
    if (id) {
      dispatch(unSelectAll());
      dispatch(getUserAgent(id));
      dispatch(openModal(MODAL_AGENT_DETAIL));
    }
  };

  return (
    <Button id="modal-user-agent-run-btn" label="Configure and Run" onClick={ onTriggerAgent } disabled={ disabled } />
  );
};

ConfigureAndRun.propTypes = {
  agent: PropTypes.object.isRequired
};

export default ConfigureAndRun;
